<template>
    <div
        class="d-block mx-auto pa-0 ma-0 position-relative"
    >
        <!-- <div
            class="position-absolute favorite-corner"
            v-if="isBook"
            @click="setBookFavoriteForUser"
        >
            <FavoriteRibbon :selected="bookFavoriteForUser" />
        </div> -->
        <v-container class="pa-0">
            <v-row justify="center" class="d-flex flex-row ma-0">
                <v-col cols="10" lg="4" class="d-flex align-center justify-center">
                    <v-img
                        :src="`${$utils.globalConstants.BASE_ASSETS_URL}/lbr/image/${book.resourceDir}/cover_medium.jpg`"
                        class="border-radius-2"
                        v-if="isBook"
                        alt="book-cover"
                        height="480"
                        max-width="350"
                        contain
                    />
                </v-col>
                <v-col cols="12" lg="8" class="text-center">
                    <v-row
                        class="flex-column ma-0 px-5 justify-center align-center justify-lg-start"
                    >
                        <!-- <v-col class="px-0 text-center d-flex flex-column" v-if="isBook">
                            <v-card-text class="text-h4 brown--text darken-4 pa-0">
                                {{ $t('bookReading.congrats') }}
                            </v-card-text>
                            <v-card-text
                                class="text-subtitle-1 pa-0 brown--text darken-3"
                                color="red"
                            >
                                {{ $t('bookReading.congrats_msg_1') }}
                            </v-card-text>
                            <v-row class="brown--text darken-3 pa-0" justify="end">
                                <v-col class="px-0" v-if="isBook">
                                    <v-row class="row d-flex align-center justify-center">
                                        <v-col
                                            class="d-flex flex-column justify-center align-center"
                                        >
                                            <span class="mb-1 font-size-16 brown--text darken-3">
                                                {{ $t('bookReading.finish_msg_1') }}
                                            </span>
                                            <star-rating
                                                :star-size="40"
                                                :show-rating="false"
                                                rounded-corners
                                                v-model="rating"
                                            />
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" sm="12">
                                    <v-textarea
                                        :label="$t('bookReading.finish_msg_2')"
                                        row-height="20"
                                        color="#4e342e"
                                        clearable
                                        v-model="commentMsg"
                                        rows="4"
                                        auto-grow
                                        outlined
                                        class="border-radius-2 white font-size-16"
                                        hide-details
                                        name="txt_note"
                                    />
                                </v-col>
                            </v-row>
                        </v-col> -->
                        <v-col class="px-0 mt-n5" v-if="isBook">
                            <v-row>
                                <v-col cols="10" offset="1" class="pb-0 font-size-20 font-weight-bolder">
                                    {{$t('bookReading.finish_book_msg_1')}}
                                </v-col>
                                <v-col cols="10" offset="1" class="font-size-14">
                                    {{$t('bookReading.finish_book_msg_2')}}
                                </v-col>
                            </v-row>
                            <v-row class="d-flex flex-row align-center justify-center">
                                <v-btn
                                    data-cy="goToLibrary-btn"
                                    dark
                                    color="#7764CA"
                                    class="text-transform-none px-12 py-5 ma-3"
                                    @click="goTo('library')"
                                >
                                    {{ $t('bookReading.go_to_library') }}
                                </v-btn>
                                <!-- <v-btn
                                    rounded
                                    color="secondary"
                                    class="px-12 py-5 ma-3"
                                    @click="goTo('home')"
                                >
                                    {{ $t('bookReading.go_to_home') }}
                                </v-btn> -->
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
/* eslint-disable global-require */

import { mapActions, mapState } from 'vuex'
import BookRatingService from '@/services/bookRating'
import FavoriteRibbon from './core/FavoriteRibbon.vue'
import global from '@/constants/GlobalConstant'

export default {
    props: {
        book: { type: Object, default: null },
    },
    components: {
        FavoriteRibbon,
    },
    data() {
        return {
            clock: require('@/assets/img/icons/clock.svg'),
            comment: require('@/assets/img/icons/comment.svg'),
            rating: 0,
            commentMsg: '',
            commentLoading: false,
            commentSent: false,
        }
    },
    methods: {
        ...mapActions('bookReading', ['setBookFavoriteForUser']),
        ratingMsg(rating) {
            switch (rating) {
                case 2:
                    return this.$t('bookReading.regular')
                case 3:
                    return this.$t('bookReading.good')
                case 4:
                    return this.$t('bookReading.very_good')
                case 5:
                    return this.$t('bookReading.excellent')
                default:
                    return this.$t('bookReading.qualification')
            }
        },
        goTo(value) {
            if (this.commentMsg || this.rating) this.sendComments()

            this.$router.push(`/user/${value}`)
        },
        async sendComments() {
            this.commentLoading = true

            await BookRatingService.updateOrCreateBookRating({
                bookUser: { id: this.user.id },
                book: { id: this.book.id },
                rating: this.rating || 0,
                ratingDate: this.$moment().format('YYYY-MM-DD hh:mm:ss'),
                description: this.commentMsg || '',
            }).catch((error) => console.error(error))
            this.$ga.event('userClick', 'sendBookComments', 'Send a book comment')
            this.commentLoading = false
        },
    },
    computed: {
        ...mapState({
            user: (state) => state.userData.user,
            currentStage: (state) => state.bookReading.currentStage,
            currentPage: (state) => state.bookReading.currentPage,
            catalog: (state) => state.bookReading.catalog,
            currentChapter: (state) => state.bookReading.currentChapter,
            currentChapterData: (state) => state.bookReading.currentChapterData,
            bookFavoriteForUser: (state) => state.bookReading.bookFavoriteForUser,
        }),
        isBook() {
            return this.book !== null
        },
    },
}
</script>
